export class NotFoundWebError extends Error {
    public readonly propagateToNextHandler: boolean;

    public constructor(message: string, propagateToNextHandler: boolean = true) {
        super(message);
        this.propagateToNextHandler = propagateToNextHandler;
    }
}
